import { createIcon } from './createIcon'

export const AutosizeIcon = createIcon({
  displayName: 'Autosize',
  viewBox: '0 0 19 15',
  path: (
    <path
      d="M-0.000326157 -8.01375e-07L1.83301 -7.21238e-07L1.83301 14.6667L-0.000326798 14.6667L-0.000326157 -8.01375e-07ZM2.74967 7.33333L6.41634 3.66667L7.69967 4.95L6.27884 6.41667L12.0538 6.41667L10.633 4.95L11.9163 3.66667L15.583 7.33333L11.9163 11L10.633 9.71667L12.0538 8.25L6.27884 8.25L7.69967 9.71667L6.41634 11L2.74967 7.33333ZM16.4997 -8.01375e-08L18.333 0L18.333 14.6667L16.4997 14.6667L16.4997 -8.01375e-08Z"
      fill="currentColor"
    />
  ),
})
